export default "__VITE_ASSET__CVkdH1vA__"